<template>
	<div class="marquee" :style="{ backgroundColor, color: textColor }" ref="marqueeRef">
		<ul ref="listRef" class="marquee-list">
			<slot />
			<!-- клоны создаются динамически -->
		</ul>
	</div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue'

const props = defineProps({
	backgroundColor: { type: String, default: '#000' },
	textColor: { type: String, default: '#fff' },
	direction: { type: String, default: 'left' },
	speed: { type: Number, default: 0.5 },
})

const marqueeRef = ref(null)
const listRef = ref(null)
let scrollAmount = 0

onMounted(async () => {
	await nextTick()

	const list = listRef.value
	const container = marqueeRef.value
	if (!list || !container) return

	const children = Array.from(list.children)
	if (!children.length) return

	const containerWidth = container.offsetWidth
	const totalItemWidth = children.reduce((sum, el) => {
		const style = getComputedStyle(el)
		return sum + el.offsetWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight)
	}, 0)

	if (totalItemWidth === 0) return

	const repeatCount = Math.ceil(containerWidth / totalItemWidth) + 1

	for (let i = 0; i < repeatCount; i++) {
		children.forEach((item) => {
			const clone = item.cloneNode(true)
			list.appendChild(clone)
		})
	}

	function scroll() {
		const allChildren = Array.from(list.children)
		const firstItem = allChildren[0]
		if (!firstItem) return

		const style = getComputedStyle(firstItem)
		const firstItemWidth =
			firstItem.offsetWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight)

		if (props.direction === 'left') {
			scrollAmount -= props.speed
			if (-scrollAmount >= firstItemWidth) {
				scrollAmount += firstItemWidth
				list.appendChild(firstItem)
			}
		} else {
			scrollAmount += props.speed
			if (scrollAmount >= firstItemWidth) {
				scrollAmount -= firstItemWidth
				list.prepend(allChildren[allChildren.length - 1])
			}
		}

		list.style.transform = `translateX(${scrollAmount}px)`
		requestAnimationFrame(scroll)
	}

	scroll()
})
</script>

<style lang="scss">
.marquee {
	overflow: hidden;
	width: 100%;
	height: 5.4rem;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	position: relative;
	z-index: 9;
	border-bottom: 6px solid var(--black);

	@media (max-width: 991.98px) {
		height: 2.3rem;
	}
}

.marquee-list {
	height: 100%;
	display: flex;
	margin: 0;
	padding: 0;
	list-style: none;
	transition: transform 0s linear;
}

.marquee-list li {
	height: 100%;
	margin: 0 1rem;
	white-space: nowrap;
	display: flex;
	align-items: center;
	font-weight: 400;
	font-size: 3.6rem;
	line-height: 116%;
	letter-spacing: 0.04em;
	text-transform: lowercase;
	text-align: center;

	@media (max-width: 991.98px) {
		font-size: 1.4rem;
		margin: 0 0.5rem;
	}

	svg {
		width: 2.6rem;
		height: 100%;
	}

	&::after {
		content: '';
		margin-left: 2rem;
		display: inline-block;
		width: 2.6rem;
		height: 100%;
		background-color: currentColor;
		mask-image: url('@/assets/svgicons/star.svg');
		mask-repeat: no-repeat;
		mask-position: center;
		mask-size: contain;

		@media (max-width: 991.98px) {
			margin-left: 1rem;
			width: 1.2rem;
		}
	}
}
</style>
